<template>
    <el-container>
        <el-header class="flex items-center justify-between shadow">
            <div class="flex items-center gap-4">
                <Logo></Logo>
                <el-popover placement="bottom-start" :width="450" trigger="click" popper-style="padding: 20px;">
                    <template #reference>
                        <el-badge :value="activeJobsCount" :hidden="activeJobsCount === 0" type="danger" :offset="[5, 5]">
                            <div class="flex items-center gap-2 cursor-pointer hover:text-blue-500 transition-colors px-2 py-1 text-sm font-medium text-gray-600">
                                <ElIconDownload :width="18" />
                                <span>Downloads</span>
                                <ElIconArrowDown :width="12" class="opacity-50" />
                            </div>
                        </el-badge>
                    </template>
                    <!-- <div class="flex items-center gap-2 mb-4 border-b pb-2">
                        <ElIconDownload :width="20" class="text-blue-500"></ElIconDownload>
                        <h3 class="my-0 text-lg font-bold">Downloads</h3>
                    </div> -->
                    <div class="max-h-[500px] overflow-auto">
                        <Downloads />
                    </div>
                </el-popover>
            </div>
            <el-menu router mode="horizontal" :default-active="$route.path" :ellipsis="false">
                <el-menu-item index="/">Home</el-menu-item>
                <el-menu-item index="/onlyfans-downloader">Onlyfans Downloader</el-menu-item>
                <el-menu-item index="/fansly-downloader">
                    Fansly Downloader
                </el-menu-item>
                <el-menu-item index="/all-downloaders">All Downloaders</el-menu-item>
                <el-menu-item index="/blog">Blog</el-menu-item>
                <el-menu-item index="/settings">Settings</el-menu-item>
                <el-menu-item v-if="store.user?._id" @click="logout()">Logout</el-menu-item>
            </el-menu>
        </el-header>
        <div class="line"></div>
        <el-container style="min-height: calc(100vh - 110px)" class="bg-gray-100 h-full">
            <el-main>
                <slot/>
            </el-main>
        </el-container>
        <el-footer height="50px" class="flex items-center bg-gray-200">
            <div>Anyloader</div> <div class="mx-2">/ </div>
            <router-link to="/logs" style="color: inherit">Logs</router-link>
        </el-footer>
    </el-container>
</template>

<script setup>
import { computed, provide, onMounted } from 'vue'
import { Download as ElIconDownload, ArrowDown as ElIconArrowDown, InfoFilled as ElIconInfoFilled } from '@element-plus/icons-vue'
import { useStore } from '~/composables/useStore'
import { useHelpers } from '~/composables/useHelpers'
import { useApi } from '~/composables/useApi'

let store = useStore()
const { useExtension, getExtensionID, waitForExtensionConnection } = useHelpers()

// Provide jobs state to children
provide('jobs', () => store.drmJobs.concat(store.dashJobs).concat(store.hlsJobs).concat(store.downloadJobs).concat(store.chunkedJobs).concat(store.nativeJobs))
provide('hlsJobs', () => store.hlsJobs)
provide('drmJobs', () => store.drmJobs)
provide('dashJobs', () => store.dashJobs)
provide('downloadJobs', () => store.downloadJobs)
provide('chunkedJobs', () => store.chunkedJobs)
provide('nativeJobs', () => store.nativeJobs)

const activeJobsCount = computed(() => {
    return store.drmJobs.length + store.dashJobs.length + store.hlsJobs.length + store.downloadJobs.length + store.chunkedJobs.length + store.nativeJobs.length
})

let messageHandler
const connectToPort = () => {
    if (typeof chrome === 'undefined' || !chrome.runtime) return
    if (window.extensionPort) {
        extensionPort.onMessage.removeListener(messageHandler)
        extensionPort.disconnect()
    }
    messageHandler = message => {
        if (message.type == 'drm_downloader_update') {
            store.drmJobs = message.data.jobs
        } else if (message.type == 'dash_downloader_update') {
            store.dashJobs = message.data.jobs
        } else if (message.type == 'hls_downloader_update') {
            store.hlsJobs = message.data.jobs
        } else if (message.type == 'chunked_downloader_update') {
            store.chunkedJobs = message.data.jobs
        } else if (message.type == 'native_downloader_update') {
            store.nativeJobs = message.data.jobs
        } else if (message.type == 'downloader_update') {
            store.downloadJobs = message.data.jobs
        }
    }
    try {
        window.extensionPort = chrome.runtime.connect(getExtensionID())
        extensionPort.onMessage.addListener(messageHandler)
    } catch (e) {
        console.error('Failed to connect to extension port:', e)
    }
}

const initJobs = async () => {
    try {
        let [drmStateReq, dashStateReq, hlsStateReq, dlStateReq, chunkedStateReq, nativeStateReq] = await Promise.all([
            useExtension('drmDownloadPool.getState', [], 'offscreen'),
            useExtension('dashDownloadPool.getState', [], 'offscreen'),
            useExtension('hlsDownloadPool.getState', [], 'offscreen'),
            useExtension('downloadPool.getState', [], 'sandbox'),
            useExtension('chunkedDownloadPool.getState', [], 'offscreen'),
            useExtension('nativeDownloadPool.getState', [], 'offscreen'),
        ])
        store.drmJobs = drmStateReq?.result?.jobs ?? []
        store.dashJobs = dashStateReq?.result?.jobs ?? []
        store.hlsJobs = hlsStateReq?.result?.jobs ?? []
        store.downloadJobs = dlStateReq?.result?.jobs ?? []
        store.chunkedJobs = chunkedStateReq?.result?.jobs ?? []
        store.nativeJobs = nativeStateReq?.result?.jobs ?? []
    } catch (e) {
        console.error('Failed to init jobs:', e)
    }
}

onMounted (async () => {
    try {
        let {result} = await useApi('/user/me', {
            headers: {
                'x-jwt-token': localStorage.getItem('jwt')
            }
        })
        store.user = result
    } catch (e) {
        console.error('Failed to fetch user:', e)
    }

    try {
        await waitForExtensionConnection({ silent: true })
        await initJobs()
        connectToPort()
    } catch (e) {
        console.error('Failed to initialize extension connection:', e)
    }
})

const logout = () => {
    store.user = null
    localStorage.removeItem('jwt')
}
</script>

<style>
.el-menu {
    border-bottom: none!important;
}

</style>